import classNames from "clsx";

import Skeleton, { SkeletonProps } from "react-loading-skeleton";

import { useThemeMode } from "@/../_metronic/partials";

export function SkeletonWrapper({ className, ...props }: SkeletonProps) {
	const { mode } = useThemeMode();

	const isDarkMode = mode === "dark";

	return (
		<Skeleton
			baseColor={isDarkMode ? "#151521" : "#ebebeb"}
			highlightColor={isDarkMode ? "#1e1e2d" : "#f5f5f5"}
			className={classNames(isDarkMode ? "skeleton-dark" : "skeleton-light", className)}
			{...props}
		/>
	);
}
